import { language } from '@/setup/i18n-setup';

const isBlank = value => value === null || value === undefined || String(value).trim() === '';

const clean = value => String(value).trim();

// Builds one locale's variant of the name, or '' when that locale has no name on file.
// `separator` sits between the prefix and the given name: '' for Thai, ' ' for English.
const buildName = (person, suffix, separator) => {
  const given = [person[`firstName${suffix}`], person[`lastName${suffix}`]]
    .filter(part => !isBlank(part))
    .map(clean)
    .join(' ');

  if (given === '') return '';

  const prefix = person.prefix ? person.prefix[`nameShort${suffix}`] : null;

  return isBlank(prefix) ? given : clean(prefix) + separator + given;
};

/**
 * The canonical display name for a teacher or student.
 *
 * Thai:    ผศ.ดร.สมชาย ใจดี          (no space after the prefix)
 * English: Asst.Prof.Dr. Somchai Jaidee  (single space after the prefix)
 *
 * When the UI is in English but the person has no English name on file, the
 * whole name falls back to the Local branch — prefix and spacing included —
 * so the result never mixes scripts.
 */
export const displayPersonName = (person, { fallback = '' } = {}) => {
  if (!person) return fallback;

  if (language() === 'Eng') {
    const english = buildName(person, 'Eng', ' ');
    if (english !== '') return english;
  }

  return buildName(person, 'Local', '') || fallback;
};

export const displayTeacherName = (person, options) => displayPersonName(person, options);

export const displayStudentName = (person, options) => displayPersonName(person, options);
